import { Component, Inject, Input, OnInit } from '@angular/core';
import { ListService } from '@app/common/services/list.service';
import { transformListToFilter } from '@app/common/utils/list.utils';
import { Restangular } from 'ngx-restangular';
import { ListModel } from '@app/common/models/list.model';
import { CallbackModel } from '@app/common/models/callback.model';
import { Callbacks } from '@app/ps/enums/callbacks.enum';
import { FinalSolutionStateEnum } from '@app/ps/enums/final-solution-state.enum';
import { AuthService } from "@app/common/services/auth.service";
import { RESTANGULAR_SYMAP } from '@app/common/services/restangular-symap.service';

@Component({
  templateUrl: './occupations-approve-change-final-solution-type-confirm.component.html',
})
export class OccupationsApproveChangeFinalSolutionTypeConfirmComponent implements OnInit {
  @Input() data: any;
  callbacks: CallbackModel;

  private list: ListModel<any>;

  readonly FinalSolutionStateEnum = FinalSolutionStateEnum;

  processed: number = 0;
  saving: boolean = false;

  occupationUpdatePaused: boolean;
  occupationUpdatePausedReason: string;

  constructor(
    private listService: ListService,
    private restangular: Restangular,
    private authService: AuthService,
    @Inject(RESTANGULAR_SYMAP) private restangularSymap: any,
  ) {
    this.proceed = this.proceed.bind(this);
  }

  async ngOnInit() {
    this.list = await this.listService.createList('occupations', {
      limit: null,
      filters: Object.assign(
        this.listService.toFilterRequestMessage(transformListToFilter({ filters: this.data.selectEntities.filters })).filters,
        {
          entityId: {
            values: this.data.selectEntities.checkedItems.map((entity: any) => entity.id),
            negation: this.data.selectEntities.inverseSelection,
          }
        }
      )
    });
    this.listService.fetchResult(this.list);

    const project = await this.restangularSymap
      .one('projects', this.authService.getActualProject().id)
      .get()
      .toPromise();
    this.occupationUpdatePaused = project.occupationUpdatePaused;
    this.occupationUpdatePausedReason = project.occupationUpdatePausedReason;
  }

  get hasOtherChange(): boolean {
    return (this.data.selectEntities.checkedItems || []).some((item: any) => item.finalSolutionOtherChange);
  }

  get countOtherChange(): number {
    let count = 0;
    for (let i = 0; i < this.data.selectEntities.checkedItems.length; i++) {
      if (this.data.selectEntities.checkedItems[i].finalSolutionOtherChange) {
        count++;
      }
    }
    return count;
  }

  getActionLabel(count: number): string {
    const isApproved = this.data.details.action === FinalSolutionStateEnum.APPROVED;

    const labels = isApproved
      ? { one: 'schválena', few: 'schváleny', other: 'schváleno' }
      : { one: 'zamítnuta', few: 'zamítnuty', other: 'zamítnuto' };

    if (count === 1) return labels.one;
    if (count >= 2 && count <= 4) return labels.few;
    return labels.other;
  }

  async proceed() {
    let updatedCount = 0;
    const totalCount = this.list.list.length;
    const failureMap: { [reason: string]: number } = {};

    for (const item of this.list.list) {
      item.finalSolutionState = this.data.details.action;
      item.finalSolutionNote = this.data.details.note || null;
      item.editMode = 'final-solution-type';
      try {
        await this.restangular.one('occupations', item.id).customPUT(item).toPromise();
        updatedCount++;
      } catch (error) {
        console.log(error);
        const reason = (error && error.data && error.data.message) || (error && error.message) || 'Neznámá chyba';
        failureMap[reason] = (failureMap[reason] || 0) + 1;
      }
    }
    const failedGroups = Object.keys(failureMap).map(reason => ({ reason, count: failureMap[reason] }));
    this.notifyParent(updatedCount, totalCount, failedGroups);
  }

  notifyParent(updatedCount: number, totalCount: number, failedGroups: Array<{ reason: string; count: number }>) {
    this.callbacks.get(Callbacks.DataValidityChanged)({
      isValid: () => false,
      data: {
        updatedCount,
        totalCount,
        failedGroups
      },
    });
  }
}
